module.exports = __webpack_public_path__ + "static/media/web-api-documentation.308d8a94.png";